// src/layouts/Root.jsx
import React from "react";
import TopNavLayout from "../components/Sidebar";

const Root = ({ children }) => {
  return (
    <>
      <TopNavLayout />

      <div className="max-w-9xl mx-auto w-full px-3 sm:px-6 lg:px-8 pt-28 pb-10">
        {children}
      </div>
    </>
  );
};

export default Root;
